import React, { Component } from "react";
import Full from "../Buttons/Full/index";
import {
  utcTimestamp,
  zones,
  amOrPm,
  getHours,
  getMinutes,
  localTime
} from "../../utils/time";
import cx from "../../utils/cx";
import s from "./index.css";

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timestamp: utcTimestamp()
    };
  }

  componentDidMount() {
    this.intervalId = setInterval(() => {
      this.setState({
        timestamp: utcTimestamp()
      });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  scrollToTime(scroller) {
    const { timezone } = this.props;
    if (scroller && !this.scroller) {
      this.scroller = scroller;
      const element = this.scroller.querySelector(`[timezone="${timezone}"]`);
      this.scrollToElement(element);
    }
  }

  scrollToElement(element) {
    if (element) {
      window.requestAnimationFrame(() => {
        const {
          top: scrollertop,
          height: scrollerheight
        } = this.scroller.getBoundingClientRect();
        const { top, height } = element.getBoundingClientRect();
        this.scroller.scrollTop =
          top + height / 2 - scrollertop - scrollerheight / 2;
      });
    }
  }

  renderTime(zone, i) {
    const { timestamp } = this.state;
    const { timezone, onChange } = this.props;
    const active = timezone === zone;
    const date = localTime(timestamp, zone);
    const time = `${getHours(date)}:${getMinutes(date)}`;
    const meridiem = amOrPm(date);
    return (
      <Full
        key={i}
        timezone={zone}
        className={cx({
          "font-18": true,
          "bg-white": !active,
          "text-blue": !active,
          "bg-blue": active,
          "text-white": active
        })}
        active={active}
        onClick={() => onChange(zone)}
      >
        <p className="m-0" style={{ lineHeight: "2em" }}>
          {time} {meridiem}
        </p>
      </Full>
    );
  }

  render() {
    const { className, style } = this.props;
    return (
      <div
        style={style}
        className={cx({
          [className]: className,
          [s.fadeEdges]: true,
          "w-100": true
        })}
      >
        <div
          className={cx([s.padding, "text-center scroll-y h-100"])}
          ref={this.scrollToTime.bind(this)}
        >
          {(zones || []).map((zone, i) => this.renderTime(zone, i))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TimezoneSelect/index.js